import { Extension } from "@tiptap/core";

export const CELL_VERTICAL_ALIGNMENT_OPTIONS = ["top", "center", "bottom"] as const;

export type CellVerticalAlignment = (typeof CELL_VERTICAL_ALIGNMENT_OPTIONS)[number];

type TableCellVerticalAlignmentOptions = {
  types: string[];
};

export const TableCellVerticalAlignment = Extension.create<TableCellVerticalAlignmentOptions>({
  name: "tableCellVerticalAlignment",

  addOptions() {
    return {
      types: ["tableCell", "tableHeader"],
    };
  },

  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          verticalAlignment: {
            default: null,
            renderHTML({ verticalAlignment }: { verticalAlignment?: string }) {
              if (!verticalAlignment || verticalAlignment === "top") {
                return null;
              }

              switch (verticalAlignment) {
                case "center":
                  return {
                    class: "[&>div]:flex [&>div]:items-center",
                  };
                case "bottom":
                  return {
                    class: "[&>div]:flex [&>div]:items-end",
                  };
                default:
                  return null;
              }
            },
          },
        },
      },
    ];
  },
});
